/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VulnerabilityResponse extends models.ThreatVulnerabilityBaseResponse {
    getFixupPrototypeFunction() { return VulnerabilityResponse.fixupPrototype; }

    static newInstance(model: Partial<VulnerabilityResponse>): VulnerabilityResponse {
        let obj = Object.assign(new VulnerabilityResponse(), model);
        VulnerabilityResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VulnerabilityResponse>): VulnerabilityResponse {
        if (!model) return null;
        return VulnerabilityResponse.newInstance(<VulnerabilityResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VulnerabilityResponse) {
        if (!obj) return;

        models.VulnerabilityResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VulnerabilityResponse): boolean {
        if (models.ThreatVulnerabilityBaseResponse.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VulnerabilityResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Unique identifier of the vulnerability.
     */
    vulnerability_id: string;

    /**
     * Reference identifier to master vulnerability source.
     */
    vulnerability_reference_id: string;

}
